import React from "react";
import cx from "classnames";

import styles from "./SubscriptionPreviewBlock.module.scss";

const SubscriptionPreviewBlock = ({ className, subscription }) => (
  <div
    className={cx("rounded p-3 border bg-white", styles.container, className)}
  >
    {subscription.products.map(({ id, product, total, variant, quantity }) => (
      <div className="d-flex flex-row" key={id}>
        <img
          className={cx("rounded", styles.img)}
          src={product.image.url}
          alt={product.title}
        />
        <div className="flex-grow-1 ms-2">
          <div className="d-flex flex-row align-items-start justify-content-between">
            <div>
              <p className="body-15 fw-medium">{product.title}</p>
              <p className="body-13 color-gray-0 mt-1">{variant.title}</p>
            </div>
            <p className="body-13 fw-bold">{total.formatted}</p>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default SubscriptionPreviewBlock;
